import request from '@/utils/request'

const api = {
  create: '/api/retail/purchase/create',
  approve: '/api/retail/purchase/approve',
  ship: '/api/retail/purchase/ship',
  receive: '/api/retail/purchase/receive',
  cancel: '/api/retail/purchase/cancel',
  detail: '/api/retail/purchase/detail',
  list: '/api/retail/purchase/list',
  platformInventoryGoods: '/api/retail/purchase/platformInventoryGoods',
  checkStock: '/api/retail/purchase/checkStock',
  returnCreate: '/api/retail/purchase/return/create',
  returnList: '/api/retail/purchase/return/list',
  returnDetail: '/api/retail/purchase/return/detail',
  lossCreate: '/api/retail/purchase/loss/create',
  lossList: '/api/retail/purchase/loss/list',
  lossDetail: '/api/retail/purchase/loss/detail',
  lossApprove: '/api/retail/purchase/loss/approve'
}

export default api

export function createPurchaseOrder(parameter) {
  return request({
    url: api.create,
    method: 'post',
    data: parameter
  })
}

export function approvePurchaseOrder(parameter) {
  return request({
    url: api.approve,
    method: 'post',
    params: parameter
  })
}

export function shipPurchaseOrder(parameter) {
  return request({
    url: api.ship,
    method: 'post',
    data: parameter
  })
}

export function receivePurchaseOrder(parameter) {
  return request({
    url: api.receive,
    method: 'post',
    data: parameter
  })
}

export function cancelPurchaseOrder(parameter) {
  return request({
    url: api.cancel,
    method: 'post',
    params: parameter
  })
}

export function getPurchaseOrderDetail(parameter) {
  return request({
    url: api.detail,
    method: 'get',
    params: parameter
  })
}

export function getPurchaseOrderList(parameter) {
  return request({
    url: api.list,
    method: 'get',
    params: parameter
  })
}

export function getPlatformInventoryGoods(parameter) {
  return request({
    url: api.platformInventoryGoods,
    method: 'get',
    params: parameter
  })
}

/**
 * 检查库存
 */
export function checkStock(parameter) {
  return request({
    url: api.checkStock,
    method: 'post',
    data: parameter
  })
}

/**
 * 创建退货单
 */
export function createPurchaseReturn(parameter) {
  return request({
    url: api.returnCreate,
    method: 'post',
    data: parameter
  })
}

/**
 * 查询退货单列表
 */
export function getReturnList(parameter) {
  return request({
    url: api.returnList,
    method: 'get',
    params: parameter
  })
}

/**
 * 查询退货单详情
 */
export function getReturnDetail(returnId) {
  return request({
    url: api.returnDetail,
    method: 'get',
    params: { returnId }
  })
}

/**
 * 创建报损单
 */
export function createPurchaseLoss(parameter) {
  return request({
    url: api.lossCreate,
    method: 'post',
    data: parameter
  })
}

/**
 * 查询报损单列表
 */
export function getLossList(parameter) {
  return request({
    url: api.lossList,
    method: 'get',
    params: parameter
  })
}

/**
 * 查询报损单详情
 */
export function getLossDetail(lossId) {
  return request({
    url: api.lossDetail,
    method: 'get',
    params: { lossId }
  })
}

/**
 * 审核报损单
 */
export function approveLoss(parameter) {
  return request({
    url: api.lossApprove,
    method: 'post',
    params: parameter
  })
}

/**
 * 别名导出，兼容已有调用
 */
export const getPurchaseDetail = getPurchaseOrderDetail
export const getPurchaseList = getPurchaseOrderList









